<template>
    <div>
        <a-tabs v-model="selectedKey">
            <a-tab-pane key="1" tab="基本信息">
                <form :form="form" @submit="handleSubmit" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :colon="false" >
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <InputField required labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" label="登录账号" type="text" id="code"
                                        :modelValue="form.code" placeholder="请输入登录账号"
                                        @update:modelValue="(value) => handleModelValueUpdate('code', value)"/>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <InputField required labelWidth="20%" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;" label="姓名" type="text" id="name"
                                        :modelValue="form.name" placeholder="请输入姓名"
                                        @update:modelValue="(value) => handleModelValueUpdate('name', value)"/>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <InputField required labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" label="手机号码" type="text" id="mobile"
                                        :modelValue="form.mobile" placeholder="请输入手机号码"
                                        @update:modelValue="(value) => handleModelValueUpdate('mobile', value)"/>
                        </a-col>
                        <a-col :lg="12" :md="12" :sm="24">
                            <SelectField required label="性别" labelWidth="20%" id="sex" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;"
                                         :modelValue="form.sex" :options="genderList"
                                         @update:modelValue="(value) => handleModelValueUpdate('sex', value)"/>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :lg="12" :md="12" :sm="24">
                            <SelectField required label="用户状态" labelWidth="35%" id="status" style="margin: 0.5rem 0.5rem;width:90%;"
                                         :modelValue="form.status" :options="statusList"
                                         @update:modelValue="(value) => handleModelValueUpdate('status', value)"/>
                        </a-col>
                    </a-row>

                    <div class="center">
                        <a-space>
                            <ButtonField text="关闭" @click="cancel" secondary />
                            <ButtonField text="下一步" primary @click="handleSubmit"/>
                        </a-space>
                    </div>
                </form>
            </a-tab-pane>
            <a-tab-pane key="2" tab="分配角色">
                <Tablelist
                    :showCheckbox="true"
                    :selectedItems="globalSelectedItems"
                    @submit-selection="handleSubmitSelection"
                    :list="roleList"
                    :columns="tableColumns"
                />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import { add } from "@/api/setting/user";
import { fetchList as fetchRoleList } from "@/api/setting/role";
import { mapGetters } from "vuex";
import encrypt from "@/utils/encrypt";
export default {
    pops:{
        visible: {
            type: Boolean,
            default: true
        },
    },
  data() {
    return {
        globalSelectedItems: {},
      visible:true,
      selectedKey: "1",
      form: {
          code:null,
          name:null,
          mobile:null,
          sex:null,
          status:null,

      },
      roleList: [],
      selectedRoleKeys: [],
      dataPermissionList: [],
      activeIndex: null,
      dataSource: [],
      total: 0,
      targetKeys: [],
      selectedDataPermission: [],
      required: true,
      tableColumns: [
            {
                key: 'code',
                title: '编码',
                field: 'code',
                infotype: 'text'
            },
            {
                key: 'name',
                title: '名称',
                field: 'name',
                infotype: 'text'
            },
            {
                key: 'remarks',
                title: '描述',
                field: 'remarks',
                infotype: 'text',
            }
        ]
    };
  },

  mounted() {
    fetchRoleList({
      pageNum: 1,
      pageSize: 1000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.roleList = Object.freeze(res.list);
      }
    });
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    genderList() {
      return this.findDataDict("gender");
    },
    statusList() {
      return this.findDataDict("status");
    },
  },

  methods: {
      handleSubmitSelection(selectedItems) {
          console.log("selectedItems:::",selectedItems)
          const selectedIds = Object.keys(selectedItems);
          selectedIds.forEach(id => {
              const item = this.roleList.find(item => item.id === id);
              if (item) {
                  const existingItem = this.selected.find(selectedItem => selectedItem.id === item.id);
                  if (!existingItem) {
                      this.selected.push(item);
                  }
              }
          });


          // this.form.validateFields((err, values) => {
          //     if (!err) {
                  add({
                      ...this.form,
                      roles: this.selectedRoleKeys,
                      password: encrypt.encrypt("123456"),
                  }).then(() => {
                      this.cancel();
                  });
              // } else {
              //     this.$message.error("请填写用户基本信息");
              //     return;
              // }
          // });
      },
        handleModelValueUpdate(fieldName, value) {
           this.form[fieldName] = value;
        },
        handleSubmit() {
              this.selectedKey = "2";
        },

        onSelectRoleChange(keys) {
          this.selectedRoleKeys = keys;
        },

        save() {
          this.form.validateFields((err, values) => {
            if (!err) {
              add({
                ...values,
                roles: this.selectedRoleKeys,
                password: encrypt.encrypt("123456"),
              }).then(() => {
                this.cancel();
              });
            } else {
              this.$message.error("请填写用户基本信息");
              return;
            }
          });
        },

        onChange(nextTargetKeys) {
          this.targetKeys = nextTargetKeys;
        },

        cancel() {
          this.$emit("close",false)
        },
      },
};
</script>

<style lang="less" scoped>
::v-deep .ant-tabs-nav .ant-tabs-tab-active{
    color: #00fd95;
    text-shadow: 0 0 0.25px #00fd95;
}
::v-deep .ant-tabs-ink-bar{
    background: #00ff96;
}
::v-deep .ant-tabs-tab{
    color:#fff;
}
</style>
